import React from 'react';

function SectionHeader(props) {
    return (
        <div className="text-2xl font-bold text-gray-700">
            {props.children}
        </div>
    );
}

export default SectionHeader;
